import useSyncJobNotification from '@/v2/domains/Jobs/hooks/useSyncJobNotification.hook';
import { useEffect } from 'react';

export default function OnQueryClientReady() {
  const { init: initSyncJobNotification } = useSyncJobNotification();

  useEffect(() => {
    initSyncJobNotification();
  }, []);

  return null;
}
